// ponytail: Embla + Ken Burns via GSAP. Autoplay casero con setInterval — no vale la pena instalar embla-carousel-autoplay para 1 llamada.
document.addEventListener('DOMContentLoaded', () => {
  if (!window.EmblaCarousel) return;

  document.querySelectorAll('.image-offer-embla').forEach((root) => {
    const viewport = root.querySelector('.embla__viewport');
    if (!viewport) return;

    const embla = window.EmblaCarousel(viewport, { loop: true, align: 'start' });

    const dotsWrap = root.querySelector('.embla__dots');
    if (dotsWrap) {
      const scrollSnaps = embla.scrollSnapList();
      scrollSnaps.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'embla__dot';
        btn.setAttribute('aria-label', `Ir a slide ${i + 1}`);
        btn.addEventListener('click', () => embla.scrollTo(i));
        dotsWrap.appendChild(btn);
      });
      const updateDots = () => {
        const idx = embla.selectedScrollSnap();
        dotsWrap.querySelectorAll('.embla__dot').forEach((d, i) => {
          d.classList.toggle('is-selected', i === idx);
        });
      };
      embla.on('select', updateDots);
      embla.on('init', updateDots);
      updateDots();
    }

    // ponytail: sin animación custom — slide horizontal nativo de Embla

    // Autoplay
    if (root.dataset.autoplay === 'true') {
      const delay = parseInt(root.dataset.delay, 10) || 4000;
      let timer = setInterval(() => embla.scrollNext(), delay);
      root.addEventListener('mouseenter', () => clearInterval(timer));
      root.addEventListener('mouseleave', () => { timer = setInterval(() => embla.scrollNext(), delay); });
    }
  });
});
